export const getLastUrlSegmentOf = (url) => url.substr(url.lastIndexOf('/')+1);


// WEBPACK FOOTER //
// ./src/utilities/getLastUrlSegmentOf.js